class FormElements {

    constructor() {}

    apply() {

        document.querySelectorAll( '.c-form-element' ).forEach( (element) => {
            this.create(element);
        });
    }

    create( element ) {

        const input = element.querySelector('input, textarea, select');

        if ( input ){

            input.addEventListener('input', this.updateIsFilled);
			input.addEventListener('input', this.updateIsFocused);
			input.addEventListener('blur', this.updateIsFocused);
			input.addEventListener('blur', this.updateIsFilled);
			input.addEventListener('focus', this.updateIsFocused);
			input.addEventListener('animationstart', this.onAnimationStart, false);


            if ( input.disabled ) {
                element.classList.add('is-disabled');
            }

            this.dispatchInput(input);
        }
    }

    dispatchInput( element ) {

        const event = document.createEvent('HTMLEvents');
		event.initEvent('input', true, false);

        element.dispatchEvent(event);
    }

    onAnimationStart( {target, animationName} ) {

        if ( animationName === 'onAutoFillStart' ) {
            target.closest('.c-form-element').classList.add('is-filled');
        }
    }

    updateIsFilled(event) {

        if ( ( event.target.value.length > 0 ) ){
            event.target.closest('.c-form-element').classList.add('is-filled');
        }
        else {
            event.target.closest('.c-form-element').classList.remove('is-filled');
        }
    }

    updateIsFocused(event) {

        if ( event.target === document.activeElement ){
            event.target.closest('.c-form-element').classList.add('is-focused');
        }
        else {
            event.target.closest('.c-form-element').classList.remove('is-focused');
        }
    }
}

export default FormElements;
